import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/SkipPrevious.svg'

export const IconSkipPrevious = IconSVG as IconComponent
